import { useApiEnvironment } from '../../context/ApiEnvironmentContext';
import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { t } from '../../utils/i18n';
import PageTabs from '../../ui/PageTabs';
import AppVersion from '../AppVersion/AppVersion';
import AppVersionPolicy from '../AppVersionPolicy/AppVersionPolicy';
import MobileRelease from '../MobileRelease/MobileRelease';
import ReleaseQueue from '../ReleaseQueue/ReleaseQueue';
import MobileReleaseOverview from './MobileReleaseOverview';
import ReleasePlanningPage from './ReleasePlanningPage';
import ReleaseContentPage from './ReleaseContentPage';
import CompanyWebHistoryPage from './CompanyWebHistoryPage';
import { MOBILE_RELEASE_CENTER_BASE as BASE, MOBILE_RELEASE_CENTER_TABS, getMobileReleaseCenterTab } from './mobileReleaseCenterRoutes';

export default function MobileReleaseCenterSection() {
  const { apiEnvironment } = useApiEnvironment();
  const { pathname } = useLocation();
  return <div className="bg-dark-bg text-dark-text">
    <div className="px-4 sm:px-6 lg:px-8"><PageTabs label={t('mobileReleaseCenter.tabs.label')} active={getMobileReleaseCenterTab(pathname)} items={MOBILE_RELEASE_CENTER_TABS.map(({ id, to }) => ({ id, to, label: t(`mobileReleaseCenter.tabs.${id}`) }))} /></div>
    <Routes key={apiEnvironment}>
      <Route index element={<Navigate to="overview" replace />} />
      <Route path="overview" element={<MobileReleaseOverview />} />
      <Route path="candidates" element={<ReleaseQueue />} />
      <Route path="plan" element={<ReleasePlanningPage />} />
      <Route path="content" element={<ReleaseContentPage />} />
      <Route path="company-web-history" element={<CompanyWebHistoryPage />} />
      <Route path="plan/candidates" element={<Navigate to={`${BASE}/candidates`} replace />} />
      <Route path="releases" element={<MobileRelease />} />
      <Route path="versions" element={<AppVersion />} />
      <Route path="policies" element={<AppVersionPolicy />} />
      <Route path="policy/versions" element={<Navigate to={`${BASE}/versions`} replace />} />
      <Route path="policy/policies" element={<Navigate to={`${BASE}/policies`} replace />} />
      <Route path="policy" element={<Navigate to={`${BASE}/versions`} replace />} />
      <Route path="*" element={<Navigate to="overview" replace />} />
    </Routes>
  </div>;
}
